import React from 'react';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/Check';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FlareIcon from '@material-ui/icons/Flare';
import { parse, format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import * as S from './styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(30),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  thirdHeading: {
    fontSize: theme.typography.pxToRem(22),
  },
  text: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.text.secondary,
  },
  obs: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 500,
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  details: {
    alignItems: 'top',
  },
}));

export default function AccordionRelease({ props, open }) {
  const classes = useStyles();

  const dataParseada = parse(
    props?.datarelease,
    'yyyy-MM-dd HH:mm:ss.S',
    new Date()
  );

  return (
    <Accordion defaultExpanded={open}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1c-content"
        id="panel1c-header"
      >
        <div className={classes.columnOne}>
          <Typography className={classes.heading}>
            Release {props?.versionrelease}
          </Typography>
          <Typography className={classes.secondaryHeading}>
            {format(dataParseada, 'd MMMM, yyyy', { locale: ptBR })}
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails
        style={{ display: 'flex', flexDirection: 'column', gap: 30 }}
      >
        <S.DetailsWraper>
          <div style={{ paddingLeft: 20, paddingRight: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <FlareIcon style={{ fontSize: 40 }} />
              <Typography variant="caption" className={classes.thirdHeading}>
                Novidades
              </Typography>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {props?.update?.map((item, index) => (
              <>
                <Typography variant="caption" className={classes.text}>
                  {item.tituloreleaseitem}.{' '}
                  <span style={{ fontWeight: 700 }}>
                    {item?.descricaoreleaseitem}
                  </span>
                </Typography>
                {index !== props.update.length - 1 && (
                  <Divider variant="fullWidth" />
                )}
              </>
            ))}
          </div>
        </S.DetailsWraper>
        <Divider variant="inset" />
        <S.DetailsWraper>
          <div style={{ paddingLeft: 20, paddingRight: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <CheckIcon style={{ fontSize: 40 }} />
              <Typography variant="caption" className={classes.thirdHeading}>
                Correções
              </Typography>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {props?.fixed?.map((item, index) => (
              <>
                <Typography variant="caption" className={classes.text}>
                  {item.tituloreleaseitem}.{' '}
                  <span style={{ fontWeight: 700 }}>
                    {item?.descricaoreleaseitem}
                  </span>
                </Typography>

                {index !== props.fixed.length - 1 && (
                  <Divider variant="fullWidth" />
                )}
              </>
            ))}
          </div>
        </S.DetailsWraper>
      </AccordionDetails>
    </Accordion>
  );
}
